import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset" style={{ position: 'relative', bottom: '15px' }}>
        <li>
          <a href="https://pithias.com/contact.html">Contact</a>
        </li>
        {/* <li>
          <a href="https://pithias.com/about.html">About us</a>
        </li> */}
        <li>
          <a href="https://pithias.com/privacy.html">Privacy policy</a>
        </li>
      </ul>
    </nav>
  );
}

export default FooterNav;